import * as React from "react";
import { Snackbar } from "@mui/material";

export default function SnackbarComponent({
	onClose = () => {},
	show = false,
	message = "Something went wrong",
}) {
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		setOpen(show);
	}, [show]);

	const handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		onClose();
		setOpen(false);
	};

	return (
		<div>
			<Snackbar
				open={open}
				autoHideDuration={3000}
				onClose={handleClose}
				message={message}
			/>
		</div>
	);
}
